export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "abbr": ["jan", "feb", "mär", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "dez"]
      },
      "days": {
        "full": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        "abbr": ["son", "mon", "die", "mit", "don", "fre", "sam"]
      },
      "patterns": {
        "longDate": "dddd, D. MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd, D. MMMM",
        "dateMedium": "dddd, D. MMMM - H[:]mm",
        "dateLarge": "D MMM YYYY [um] H[:]mm[:]ss",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "Tausend", "Million", "Billion"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function(number) { return number + (number === 1 ? 'er' : '.'); }
    }
  },
  "translations": {
    "messages": {
  " CASH ": [
    null,
    ""
  ],
  "!action:Deposit": [
    null,
    "!action:Einzahlen"
  ],
  "!desc:AddCitizenCard": [
    null,
    ""
  ],
  "!desc:BetRefundOffer": [
    null,
    "!desc:BetRefundOffer"
  ],
  "!desc:BetRefundOffer100": [
    null,
    "!desc:BetRefundAngebot100"
  ],
  "!desc:CondBetRefundOffer": [
    null,
    "!desc:CondBetRefundOffer"
  ],
  "!desc:CondFirstDeposit": [
    null,
    "!desc:CondFirstDeposit"
  ],
  "!desc:DefaultLandingContent": [
    null,
    ""
  ],
  "!desc:DefaultLandingContentES": [
    null,
    ""
  ],
  "!desc:DefaultLandingMobileContent": [
    null,
    ""
  ],
  "!desc:DefaultLandingPageTitleES": [
    null,
    ""
  ],
  "!desc:DefaultLandingTitleES": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingContent": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingMobileContent": [
    null,
    ""
  ],
  "!placeholder:dd": [
    null,
    "TT"
  ],
  "!placeholder:mm": [
    null,
    "MM"
  ],
  "!placeholder:yy": [
    null,
    "yy"
  ],
  "!placeholder:yyyy": [
    null,
    "JJJJ"
  ],
  ", if you lost": [
    null,
    ""
  ],
  "1st bet refunded up to €100": [
    null,
    "Direkt bis zu 100 € in Freebets."
  ],
  "A photo of the back of your ID document will also be required to validate your account.": [
    null,
    "Ein Foto der Rückseite deines Ausweises wird ebenfalls benötigt, um dein Konto zu bestätigen."
  ],
  "A receipt for your rent": [
    null,
    "Bestätigung über Mietzahlung bzw. Mietvertrag"
  ],
  "Above": [
    null,
    "Oben"
  ],
  "Acceptable ID": [
    null,
    "Akzeptierte Ausweisdokumente"
  ],
  "Acceptable formats: %1$s.": [
    null,
    "Akzeptierte Formate: %1$s."
  ],
  "Acceptable proof of address documents": [
    null,
    "Akzeptierte Adress-Nachweise"
  ],
  "Account already exist": [
    null,
    "Account existiert bereits"
  ],
  "Account creation complete": [
    null,
    "Dein Konto wurde erstellt"
  ],
  "Account creation: complete.<br />That's what<br />we're talking about!": [
    null,
    "Noch ein Schritt zu deinem Bonus!"
  ],
  "Account number": [
    null,
    "Numéro de compte"
  ],
  "Activation code": [
    null,
    "Aktivierungscode"
  ],
  "Add a bank card": [
    null,
    "Eine Bankkarte hinzufügen"
  ],
  "Add my bank card": [
    null,
    "Meine Bank-Karte hinzufügen"
  ],
  "Add my bank card details": [
    null,
    "Details meiner Bank-Karte hinzufügen"
  ],
  "Address details": [
    null,
    "Adress-Details"
  ],
  "All countries": [
    null,
    "Alle Länder"
  ],
  "An error has occured when checking your CAPTCHA score. Please try again later.": [
    null,
    "Bei der Überprüfung deines CAPTCHA-Scores ist ein Fehler aufgetreten. Bitte versuch es später erneut. "
  ],
  "Analysis": [
    null,
    "Analyse"
  ],
  "Automatic withdrawal": [
    null,
    "Automatische Auszahlung"
  ],
  "Automatic withdrawal threshold": [
    null,
    ""
  ],
  "BOOM! You can start playing!": [
    null,
    "Kassiere deinen Bonus!"
  ],
  "Back": [
    null,
    "Zurück"
  ],
  "Back to homepage": [
    null,
    "Zurück zur Homepage"
  ],
  "Bank": [
    null,
    "Bank"
  ],
  "Bank accounts from this country are not accepted on Winamax": [
    null,
    "Bankkonten aus diesem Land werden auf Winamax nicht akzeptiert"
  ],
  "Bank card number": [
    null,
    "Bank-Karten-Nummer"
  ],
  "Bank code": [
    null,
    "Bankleitzahl"
  ],
  "Bank details": [
    null,
    "Banken-Details"
  ],
  "Bank office": [
    null,
    "Bank Filiale "
  ],
  "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100.": [
    null,
    "Bevor du überhaupt eine Aktion auf unserer Website durchführst, bieten wir dir deine erste Einzahlung in Form von Freebets bis zu 100 € an."
  ],
  "Beginner": [
    null,
    ""
  ],
  "Beginner profile token": [
    null,
    ""
  ],
  "Beneficiary": [
    null,
    "Begünstigter"
  ],
  "Bet on sports": [
    null,
    "Auf den Sport wetten"
  ],
  "Betting limit - Poker": [
    null,
    ""
  ],
  "Betting limit - Sport betting": [
    null,
    ""
  ],
  "Birth date": [
    null,
    "Geburtsdatum"
  ],
  "Birth name": [
    null,
    "Geburtsname"
  ],
  "Bonus up to €250": [
    null,
    "Bonus bis 250 €"
  ],
  "Boom!": [
    null,
    "Boom!"
  ],
  "By ticking this box, you agree that you have read and accepted our": [
    null,
    "Indem du dieses Kästchen ankreuzt, erklärst du, dass du unsere Nutzungsbedingungen gelesen und akzeptiert hast."
  ],
  "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)": [
    null,
    "CAPTCHA Fehler. Bitte erneut versuchen. Du wirst automatisch auf die Winamax-Hompage weitergeleitet. (%1$s)"
  ],
  "Card number": [
    null,
    "Kartennummer"
  ],
  "Change address": [
    null,
    "Adresse ändern"
  ],
  "Change my deposit limit": [
    null,
    "Mein Einzahlungslimit ändern"
  ],
  "Change my limit": [
    null,
    "Mein Limit ändern"
  ],
  "Change your account details in order to receive your activation code by post.": [
    null,
    "Account-Details ändern, um deinen Aktivierungscode per Post zu erhalten."
  ],
  "Check that your bank card information is accurate and complete the cryptogram.": [
    null,
    "Bitte stell sicher, dass deine Angaben korrekt sind und vervollständige das Kryptogramm."
  ],
  "Choose a deposit method in order to make your first deposit.": [
    null,
    "Eine Einzahlungsmethode für die deine Einzahlung wählen."
  ],
  "Choose a deposit method.": [
    null,
    "Eine Einzahlungsmethode auswählen."
  ],
  "Choose the amount of your first deposit in order to start playing.": [
    null,
    "Wähle den Betrag deiner ersten Einzahlung, um zu beginnen."
  ],
  "Choose the amount you wish to deposit in order to continue playing.": [
    null,
    "Wählen deinen Einzahlungsbetrag, um weiterhin zu spielen."
  ],
  "Choose the maximum amount you wish to deposit per month.": [
    null,
    "Wie viel möchtest du maximal pro Monat auf dein Konto einzahlen? Du kannst dieses Limit jederzeit in deinen Einstellungen ändern."
  ],
  "Choose the maximum amount you wish to deposit per week.": [
    null,
    "Wie viel möchtest du maximal pro Woche auf dein Konto einzahlen? Du kannst dieses Limit jederzeit in deinen Einstellungen ändern."
  ],
  "Choose the profile that best suits your playing style! You can also change the values manually.": [
    null,
    ""
  ],
  "Choose which bank card you want to use to make a deposit.": [
    null,
    "Wähl eine Bankkarte für die Einzahlung."
  ],
  "Choose your country code": [
    null,
    "Wähle dein Land aus"
  ],
  "Choose your limit well in order to take advantage of your <b>first bet refunded up to €100</b>": [
    null,
    "Wähle bewusst dein Limit, um direkt <b>bis zu 100 € in Freebets </b>zu erhalten."
  ],
  "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society.": [
    null,
    "Wie soll dein Username lauten?<br />Sei kreativ. Das ist dein Markenzeichen!"
  ],
  "Citizen card": [
    null,
    ""
  ],
  "Citizen card number": [
    null,
    ""
  ],
  "City": [
    null,
    "Ort"
  ],
  "Click & drag your file here": [
    null,
    "Datei per Drag & Drop hierher ziehen"
  ],
  "Close": [
    null,
    "Schließen"
  ],
  "Come and take a seat": [
    null,
    "Komm rein und nimm Platz"
  ],
  "Complete registration now": [
    null,
    "Registrierung jetzt abschließen"
  ],
  "Confirm limit": [
    null,
    "Limit bestätigen"
  ],
  "Confirm my details": [
    null,
    "Meine Angaben bestätigen"
  ],
  "Confirm my limit": [
    null,
    "Mein Limit bestätigen"
  ],
  "Confirm your details in order to receive a new activation code by post.": [
    null,
    "Bestätige deine Angaben, um einen neuen Aktivierungscode zu erhalten."
  ],
  "Continue": [
    null,
    "Fortfahren"
  ],
  "Continue my deposit": [
    null,
    "Meine Einzahlung fortsetzen"
  ],
  "Continue with PayPal": [
    null,
    "Weiter mit PayPal"
  ],
  "Country": [
    null,
    "Land"
  ],
  "Country of birth": [
    null,
    "Geburtsland"
  ],
  "Country of residence": [
    null,
    "Wohnsitz"
  ],
  "Create my account": [
    null,
    "Konto eröffnen"
  ],
  "Creation": [
    null,
    "Erstellen"
  ],
  "Cryptogram": [
    null,
    "Kryptogramm"
  ],
  "Deposit": [
    null,
    "Einzahlung"
  ],
  "Deposit limit": [
    null,
    "Dein persönliches Einzahlungslimit"
  ],
  "Deposit on my account": [
    null,
    "Auf meinen Account einzahlen"
  ],
  "Deposit on your Winamax account by bank transfer": [
    null,
    "Eine Einzahlung auf Winamax per Banküberweisung vornehmen"
  ],
  "Deposit on your account with Neteller.": [
    null,
    "Mit Neteller einzahlen."
  ],
  "Deposit with Moneybookers/Skrill.": [
    null,
    "Mit Moneybookers/Skrill einzahlen."
  ],
  "Document": [
    null,
    "Dokument"
  ],
  "Document number": [
    null,
    "Nummer des Dokuments"
  ],
  "Driver's licence": [
    null,
    "Führerschein"
  ],
  "Driver's license": [
    null,
    "Führerschein"
  ],
  "Driver's license: whole document with photo or front and back sides": [
    null,
    "Führerschein: ganzes Dokumente mit Photo oder Vorder- und Rückseite"
  ],
  "Edit email/phone number": [
    null,
    "E-Mail/Telefonnummer bearbeiten"
  ],
  "Email": [
    null,
    "E-Mail"
  ],
  "Employed worker": [
    null,
    "Angestellter"
  ],
  "Enter a different amount": [
    null,
    "Einen anderen Betrag eingeben"
  ],
  "Enter amount": [
    null,
    "Betrag eingeben"
  ],
  "Enter my information": [
    null,
    "Meine Informationen eingeben"
  ],
  "Enter the activation code sent to you by post.": [
    null,
    "Gib bitte den per Post erhaltenen Aktivierungscode ein. "
  ],
  "Enter the code sent by text message to %1$s to verify your phone number.": [
    null,
    "Den Code eingeben, der per SMS an %1$s gesendet wurde, um deine Telefonnummer zu bestätigen."
  ],
  "Experienced": [
    null,
    ""
  ],
  "Experienced profile token": [
    null,
    ""
  ],
  "Expiry date": [
    null,
    "Ablaufdatum"
  ],
  "Feel free to discover the platform at a later date if you so wish.": [
    null,
    "Du kannst die Plattform auch zu einem späteren Zeitpunkt entdecken. "
  ],
  "Female": [
    null,
    "Weiblich"
  ],
  "Fill in my details": [
    null,
    "Details eintragen"
  ],
  "Fill out the following form. Or directly fill out the informations with Paypal": [
    null,
    "Bitte fülle das folgende Formular aus. Das geht auch schnell und direkt mit einem Klick über Paypal."
  ],
  "Fill out the form with your bank card information.": [
    null,
    "Bitte fülle die Form mit deinen Bankdaten aus."
  ],
  "First deposit": [
    null,
    "Erste Einzahlung"
  ],
  "First name": [
    null,
    "Vorname"
  ],
  "For a Spanish nationality, you must supply us with a DNI and not a NIE": [
    null,
    "Als Spanischer Staatsangehöriger, schicken uns bitte eine DNI und keine NIE"
  ],
  "For a foreign nationality, you must supply us with a NIE and not a DNI": [
    null,
    "Als ausländischer Staatsbürger, schicken Sie uns bitte eine NIE und keine DNI"
  ],
  "Free registration": [
    null,
    "Kostenlos registrieren"
  ],
  "Full name on card": [
    null,
    "Vollständiger Name auf der Karte"
  ],
  "GG!<br />Your account has<br />been validated!": [
    null,
    "GG!<br />Dein Account wurde<br />bestätigt!"
  ],
  "Gambling is prohibited for minors": [
    null,
    "Glücksspiele sind für \nMinderjährige verboten"
  ],
  "General Terms and Conditions": [
    null,
    "Allgemeine Geschäftsbedingungen"
  ],
  "Health card: front and back": [
    null,
    "Krankenversicherungskarte: Vorder- und Rückseite"
  ],
  "Hold on": [
    null,
    "Einen Augenblick"
  ],
  "I accept the ": [
    null,
    "Ich akzeptiere die "
  ],
  "I agree to gain access to all": [
    null,
    ""
  ],
  "I certify that I own this bank account": [
    null,
    "Ich bestätige, dass ich Eigentümer dieses Bankkontos bin"
  ],
  "I have not received my code": [
    null,
    "Ich habe meinen Code nicht erhalten"
  ],
  "I have read and accept the": [
    null,
    ""
  ],
  "I need a new code": [
    null,
    "Ich brauche einen neuen Code"
  ],
  "I want to receive offers and news": [
    null,
    ""
  ],
  "I will deposit later": [
    null,
    "Ich zahle später ein"
  ],
  "I will send it at a later time": [
    null,
    "Später senden"
  ],
  "I would like to receive the newsletter and be kept up to date on all the latest bonuses and promotions": [
    null,
    "Ich möchte Angebote und Newsletter von Winamax erhalten"
  ],
  "IBAN": [
    null,
    "IBAN"
  ],
  "IBAN number": [
    null,
    "IBAN Nummer"
  ],
  "ID card: front and back": [
    null,
    "ID Dokument: Vorder- und Rückseite"
  ],
  "ID card: front side": [
    null,
    "Personalausweis: Vorderseite"
  ],
  "Identity card": [
    null,
    "Personalausweis"
  ],
  "Identity document number": [
    null,
    ""
  ],
  "Identity not verified": [
    null,
    "Identität nicht validiert"
  ],
  "If you are not resident in Germany, you can register on": [
    null,
    "Falls Dein Wohnsitz nicht in Deutschland ist, melde dich auf"
  ],
  "Important! Make sure you add the folloing reference for your transfer:": [
    null,
    "Wichtig! Bitte gib die folgende Referenz für deinen Transfer an:"
  ],
  "In 30 seconds": [
    null,
    "In 30 Sekunden"
  ],
  "In order to make your deposit, add your bank card or any other deposit method.": [
    null,
    "Um eine Einzahlung vorzunehmen, füge deine Bankkarte oder eine andere Einzahlungsoption hinzu."
  ],
  "In order to make your first deposit, add your bank card or any other deposit method.": [
    null,
    "Um deine erste Einzahlung vorzunehmen, füge deine Bankkarte oder eine andere Einzahlungsoption hinzu."
  ],
  "In order to play for real money, you must send us a proof of address.": [
    null,
    "Um um echtes Geld spielen zu können, musst du uns einen Adressnachweis schicken"
  ],
  "In order to play for real money, you must send us an ID.": [
    null,
    "Um um echtes Geld spielen zu können, musst du uns eine ID schicken."
  ],
  "In order to validate your account, you must upload a photo of your ID.": [
    null,
    "Um deinen Account zu bestätigen, musst du ein Foto deines Ausweisdokuments hochladen."
  ],
  "Incorrect format in this field": [
    null,
    "Inkorrektes Format in diesem Feld"
  ],
  "Incorrect tax code": [
    null,
    "Code fiscal incorrect"
  ],
  "Incorrect value in this field, the department does not match the city.": [
    null,
    "Das Bundesland korrespondiert nicht mit der angegebenen Stadt."
  ],
  "Independent professional": [
    null,
    "Freelancer"
  ],
  "Internal error": [
    null,
    "Interner Fehler"
  ],
  "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers.": [
    null,
    "Das Format der NIE-Nummer ist ungültig. Diese muss mit E oder C beginnen, gefolgt von 8 Ziffern."
  ],
  "Invalid phone number format.": [
    null,
    "Ungültiges Telefonnummer-Format."
  ],
  "It seems there is a connection problem": [
    null,
    "Es scheint ein Verbindungsproblem vorzuliegen. "
  ],
  "It would be a shame to stop so close to the finish line!": [
    null,
    "Es wäre doch schade, so kurz vor dem Ziel aufzuhören!"
  ],
  "It's time to get serious": [
    null,
    "Jetzt wird es ernst"
  ],
  "Join Winamax and take advantage of our welcome offer!": [
    null,
    "Komm zu Winamax und profitiere von unseren Willkommensangeboten!"
  ],
  "Keep an <br />eye on your<br />dough!": [
    null,
    "Behalte <br />deine Knete<br />im Auge!"
  ],
  "Last name": [
    null,
    "Nachname"
  ],
  "Last<br />sprint!": [
    null,
    "Endspurt<br />!"
  ],
  "Leave": [
    null,
    "Verlassen"
  ],
  "Leave registration": [
    null,
    ""
  ],
  "Leaving us already?": [
    null,
    "Gehst du schon?"
  ],
  "Loading...": [
    null,
    "Lädt..."
  ],
  "Log in": [
    null,
    "Anmelden"
  ],
  "Make a deposit": [
    null,
    "Eine Einzahlung vornehmen"
  ],
  "Male": [
    null,
    "Männlich"
  ],
  "Maximum amount per month": [
    null,
    "Höchstbetrag pro Monat"
  ],
  "Maximum amount per week": [
    null,
    "Höchstbetrag pro Woche"
  ],
  "Missing application initialization parameters. Please try again.": [
    null,
    "Fehlende App-Initiations-Einstellungen. Bitte versuch es später erneut. "
  ],
  "Moneybookers email": [
    null,
    "Moneybookers-E-Mail"
  ],
  "Must contain at least 3 of the following characters: (0-9), (a-z), (A-Z) and symbols (ex @, !, #, $).": [
    null,
    "Muss mindestens 3 der folgenden Zeichen enthalten: (0-9), (a-z), (A-Z) und Symbole (z. B. @, !, #, $)."
  ],
  "NIE number": [
    null,
    "NIE-Support Nummer"
  ],
  "Nationality": [
    null,
    "Nationalität"
  ],
  "Neteller Secure ID": [
    null,
    "Neteller Secure ID"
  ],
  "Neteller account": [
    null,
    "Neteller Account"
  ],
  "No godfather found for this code": [
    null,
    ""
  ],
  "No minors": [
    null,
    "Minderjährigen ist die Benutzung verboten"
  ],
  "Occupation": [
    null,
    "Beruf"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Oops,": [
    null,
    "Oops,"
  ],
  "Open your account": [
    null,
    "Konto eröffnen"
  ],
  "Optional": [
    null,
    "Optional"
  ],
  "Other": [
    null,
    "Anderes"
  ],
  "Other deposit methods": [
    null,
    "Andere Einzahlungsmethoden"
  ],
  "Other document": [
    null,
    ""
  ],
  "Other suggestions": [
    null,
    "Andere Vorschläge"
  ],
  "Our bank details for your transfer:": [
    null,
    "Unsere Bankdaten für den Transfer:"
  ],
  "Passport": [
    null,
    "Reisepass"
  ],
  "Passport: whole page with photo": [
    null,
    "Reisepass: ganze Seite mit Foto"
  ],
  "Password": [
    null,
    "Passwort"
  ],
  "Per month": [
    null,
    "Pro Monat"
  ],
  "Per week": [
    null,
    "Pro Woche"
  ],
  "Personal information": [
    null,
    "Deine persönlichen Daten"
  ],
  "Phone number": [
    null,
    "Telefonnummer"
  ],
  "Phone, internet, water, gas or electricity bills": [
    null,
    "Telefon-, Internet, Wasser-, Gas und Stromrechnungen"
  ],
  "Place of birth": [
    null,
    "Geburtsort"
  ],
  "Play on the app !": [
    null,
    "Spiele in der App!"
  ],
  "Play poker": [
    null,
    "Poker spielen"
  ],
  "Play time - Poker": [
    null,
    ""
  ],
  "Poker Terms and Conditions": [
    null,
    "Poker-Geschäftsbedingungen"
  ],
  "Postal address": [
    null,
    "Postanschrift"
  ],
  "Postal code": [
    null,
    "Postleitzahl"
  ],
  "Privacy Policy": [
    null,
    "Datenschutzerklärung"
  ],
  "Privacy and Cookies Policy": [
    null,
    ""
  ],
  "Processing": [
    null,
    "Wird bearbeitet"
  ],
  "Protect your behind!": [
    null,
    "Deine Limits festlegen"
  ],
  "Protect<br />your<br />behind!": [
    null,
    "Deine Limits<br />festlegen"
  ],
  "Province": [
    null,
    "Bundesland"
  ],
  "RIB key": [
    null,
    "IBAN Schlüssel"
  ],
  "Reference": [
    null,
    "Referenz"
  ],
  "Referral": [
    null,
    ""
  ],
  "Referral code": [
    null,
    ""
  ],
  "Region of birth": [
    null,
    "Geburtsregion"
  ],
  "Register": [
    null,
    "Konto eröffnen"
  ],
  "Register with my email": [
    null,
    "Mit meiner E-Mail-Adresse registrieren"
  ],
  "Register with my phone number": [
    null,
    "Mit meiner Telefonnummer registrieren"
  ],
  "Registration": [
    null,
    "Erstelle dein Konto"
  ],
  "Registration complete!": [
    null,
    ""
  ],
  "Registration not allowed from this country of residence.": [
    null,
    "Eine Anmeldung aus diesem Land ist leider nicht möglich."
  ],
  "Regular": [
    null,
    ""
  ],
  "Regular profile token": [
    null,
    ""
  ],
  "Residence permit: front and back": [
    null,
    "Aufenthaltstitel: Vorder- und Rückseite"
  ],
  "Responsible gaming": [
    null,
    "Verantwortungsvolles Spiel"
  ],
  "Retired": [
    null,
    "Rentner"
  ],
  "SWIFT code": [
    null,
    "SWIFT Code"
  ],
  "Save this card for future deposits": [
    null,
    "Diese Karte für weitere Einzahlungen speichern"
  ],
  "Scan my ID": [
    null,
    "Mein ID-Dokument scannen"
  ],
  "Scan my bank card": [
    null,
    "Meine Bank-Karte scannen"
  ],
  "Scan my verification document": [
    null,
    "Mein Dokument scannen"
  ],
  "Search": [
    null,
    "Suchen"
  ],
  "See Ts&Cs for the offer": [
    null,
    "AGB des Angebots ansehen"
  ],
  "See accepted verification documents": [
    null,
    "Die bestätigten Dokumente anzeigen"
  ],
  "See what IDs we accept": [
    null,
    "Ansehen, welche ID-Dokumente wir akzeptieren"
  ],
  "Select your file": [
    null,
    "Deine Datei auswählen"
  ],
  "Self-employed": [
    null,
    "Selbstständig"
  ],
  "Send ID": [
    null,
    "Send ID "
  ],
  "Send back of document": [
    null,
    "Rücksendung des Dokuments"
  ],
  "Send documents": [
    null,
    "Dokumente senden"
  ],
  "Send my ID": [
    null,
    "Meine ID senden"
  ],
  "Send my new code": [
    null,
    "Neuen Code senden"
  ],
  "Send my verification documents": [
    null,
    "Meine Bestätigungs-Dokumente senden"
  ],
  "Send proof of identity": [
    null,
    "Identitätsnachweis senden"
  ],
  "Sex": [
    null,
    "Geschlecht"
  ],
  "Show<br />us who<br />you are!": [
    null,
    "Zeig<br />uns, wer<br />Du bist!"
  ],
  "Skip this step": [
    null,
    "Diesen Schritt überspringen"
  ],
  "Skrill email": [
    null,
    "E-Mail Skrill"
  ],
  "Social security card": [
    null,
    "Sozialversicherungskarte"
  ],
  "Sports betting Terms and Conditions": [
    null,
    "Sportwetten-Geschäftsbedingungen"
  ],
  "Starting at €%1$s": [
    null,
    "Beginnt bei %1$s €"
  ],
  "Student": [
    null,
    "Student"
  ],
  "Successfully uploaded!": [
    null,
    "Erfolgreich hochgeladen!"
  ],
  "Super-player created!": [
    null,
    "Super-Spieler erstellt!"
  ],
  "Surname": [
    null,
    "Zweiter Name"
  ],
  "Take 2 minutes to create your account.": [
    null,
    "Nimm dir 2 Minuten Zeit, um dein Konto zu erstellen."
  ],
  "Tax Code": [
    null,
    "Code Fiscal"
  ],
  "Tax bill or home insurance letter": [
    null,
    "Steuerbescheid oder Schreiben von Versicherung"
  ],
  "Terms and Conditions": [
    null,
    "Nutzungsbedingungen"
  ],
  "The activation code cannot be over %1$s characters.": [
    null,
    "Der Aktivierungscode darf nicht mehr als %1$s Zeichen haben."
  ],
  "The activation code is not valid.": [
    null,
    "Der Aktivierungscode ist ungültig."
  ],
  "The best odds are your odds": [
    null,
    "Die beste Quoten sind deine Quoten"
  ],
  "The current process seems to be slow. Try again.": [
    null,
    "Dieser Prozess dauert zu lange. Erneut versuchen."
  ],
  "The identity verification service is unavailable. Please try again later.": [
    null,
    "Der Service zur Validierung deiner Dokumente steht nicht zur Verfügung. Bitte versuch es später nochmal."
  ],
  "The maximum amount of time (in hours) you can spend at the poker tables each week.": [
    null,
    ""
  ],
  "The maximum amount you can deposit into your account each week for sports betting and poker.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on poker each week.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on sports betting each week.": [
    null,
    ""
  ],
  "The registration process is only available for Portuguese citizens.": [
    null,
    ""
  ],
  "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!": [
    null,
    ""
  ],
  "There already exists an account with this email address.": [
    null,
    "Es existiert bereits ein Account mit dieser E-Mail-Adresse."
  ],
  "These deposit methods are not available for this amount.": [
    null,
    "Dies Einzahlungsmethoden stehen für diesen Betrag nicht zur Verfügung."
  ],
  "This code is required to create your account.": [
    null,
    "Dieser Code wird benötigt, um deinen Account zu bestätigen."
  ],
  "This document must mention your name and IBAN number.": [
    null,
    "Dieses Dokument muss deinen Namen und deine IBAN-Nummer enthalten."
  ],
  "This field is mandatory to validate your deposit.": [
    null,
    "Dies ist ein Pflichtfeld, um die Einzahlung zu bestätigen."
  ],
  "This file format is invalid. Please try in one of the following formats: %1$s.": [
    null,
    "Dieses Dateiformat ist ungültig. Bitte benutze eins der folgenden Formate: %1$s."
  ],
  "This fiscal code is already linked to an active account": [
    null,
    "Diese Steuernummer gehört bereits zu einem anderen aktiven Account"
  ],
  "This limit can be changed at any time in your account.": [
    null,
    ""
  ],
  "This limit is mandatory for your account validation.": [
    null,
    "Dieses Limit ist verpflichtend, um deinen Account zu bestätigen."
  ],
  "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)": [
    null,
    "Dieses Passwort enthält nicht mindestens 3 der folgenden Zeichen: (0-9), (a-z), (A-Z) sowie Sonderzeichen (ex @, !, #, $)"
  ],
  "This referral code is not valid.": [
    null,
    ""
  ],
  "This threshold can be changed at any time from your account.": [
    null,
    ""
  ],
  "This username is unavailable.": [
    null,
    "Dieser Username ist nicht verfügbar."
  ],
  "This way for<br />money": [
    null,
    "Hier lang zum<br />Geld"
  ],
  "To finish your account validation, please upload a proof of bank account's property.": [
    null,
    "Um die Validierung deines Kontos abzuschließen, lade bitte einen Nachweis über das Eigentum an deinem Bankkonto hoch."
  ],
  "Too many attempts with this identity. Please try again later.": [
    null,
    "Zu viele erfolglose Anmeldeversuche. Bitte versuch es später noch einmal."
  ],
  "Trainee": [
    null,
    "Trainee"
  ],
  "Try again": [
    null,
    "Erneut versuchen"
  ],
  "Ts&Cs": [
    null,
    "AGB und Datenschutzbestimmungen"
  ],
  "Ts&Cs for the offer": [
    null,
    "AGB des Angebots"
  ],
  "Type of cash-out": [
    null,
    "Auszahlungsart"
  ],
  "Type of document": [
    null,
    "Art des Dokuments"
  ],
  "Unable to load profile information.": [
    null,
    "Laden der Profil-Informationen nicht möglich. "
  ],
  "Unable to send verification message.": [
    null,
    "Senden einer Bestätigung nicht möglich."
  ],
  "Unauthorised email.": [
    null,
    "Diese E-Mail Adresse ist nicht zulässig."
  ],
  "Unemployed": [
    null,
    "Arbeitslos"
  ],
  "Up to": [
    null,
    "Bis zu"
  ],
  "Up to a limit of €100 or the same amount as your first deposit": [
    null,
    ""
  ],
  "Up to €100 free, instantly!": [
    null,
    "Direkt bis zu 100 € in Freebets. "
  ],
  "Upload an identity document to continue registration.": [
    null,
    ""
  ],
  "Upload my ID": [
    null,
    "Mein ID-Dokument hochladen"
  ],
  "Upload my verification document": [
    null,
    "Mein Dokument hochladen"
  ],
  "Upload your bank document": [
    null,
    "Lade dein Bank-Dokument hoch. "
  ],
  "Use France Connect": [
    null,
    "France Connect verwenden"
  ],
  "Use my existing deposit limit. If none is available, the limit set by you above will be applied.": [
    null,
    "Mein bereits bestehendes Einzahlungslimit verwenden. Falls nicht vorhanden, wird das Limit verwendet, das du hier oben festlegst."
  ],
  "Used or married name": [
    null,
    "Geburtsname"
  ],
  "Username": [
    null,
    "Dein eigener Username"
  ],
  "Validate": [
    null,
    "Bestätigen"
  ],
  "Validate my deposit": [
    null,
    "Meine Einzahlung bestätigen"
  ],
  "Validate my information": [
    null,
    "Daten bestätigen"
  ],
  "Validate my limit": [
    null,
    "Mein Limit bestätigen"
  ],
  "Validate my username": [
    null,
    "Username bestätigen"
  ],
  "Validation code": [
    null,
    "Bestätigungscode"
  ],
  "Verification": [
    null,
    "Verifizierung"
  ],
  "Verify your phone number to receive a new text message with your validation code.": [
    null,
    "Bestätige deine Telefonnummer, um eine SMS mit deinem Bestätigungscode zu erhalten."
  ],
  "Want to start playing? Make a deposit now.": [
    null,
    "Du willst anfangen zu spielen. Mach jetzt eine Einzahlung. "
  ],
  "Want to<br />create a<br />username?": [
    null,
    "Einen Username<br />erstellen<br />"
  ],
  "We are also offering a bonus of equal value to your first deposit.": [
    null,
    "Du erhältst direkt bis zu 100 € in Freebets in Höhe deiner ersten Einzahlung. "
  ],
  "We cannot accept land-line numbers.": [
    null,
    "Wir können keine Festnetznummern akzeptieren."
  ],
  "We will refund your 1st bet up to €100.": [
    null,
    "Du erhältst direkt bis zu 100 € in Freebets. "
  ],
  "We're fetching your data...": [
    null,
    "Wir rufen deine Daten ab..."
  ],
  "We're missing your identity documents to complete your registration.": [
    null,
    "Uns fehlen deine Ausweispapiere, um deine Anmeldung abzuschließen."
  ],
  "Weekly betting limits": [
    null,
    ""
  ],
  "Welcome bonus": [
    null,
    ""
  ],
  "Welcome to Winamax": [
    null,
    ""
  ],
  "Welcome<br />to<br />Winamax!": [
    null,
    "Willkommen<br />auf<br />Winamax!"
  ],
  "What is France Connect": [
    null,
    "Was ist France Connect"
  ],
  "With 168h per week, you can play for an unlimited period": [
    null,
    ""
  ],
  "Withdrawable cash credited to your account directly after the result of the first bet": [
    null,
    ""
  ],
  "Without a professional activity": [
    null,
    "Ohne berufliche Tätigkeit"
  ],
  "You are already registered.": [
    null,
    "Du bist bereits angemeldet."
  ],
  "You are not authorized to access this service.": [
    null,
    "Zugang zu diesem Service ist leider nicht möglich. "
  ],
  "You are not permitted to create an account from this country.": [
    null,
    "In diesem Land kannst du leider keinen Account erstellen. "
  ],
  "You are not permitted to create this user account.": [
    null,
    "Diesen Account kannst du leider nicht erstellen. "
  ],
  "You are on the Interior Ministry's banned player list!": [
    null,
    "Du stehst auf der zentralen Sperrdatei"
  ],
  "You can change this option at any time from your account": [
    null,
    ""
  ],
  "You can continue playing on Winamax in the meantime.": [
    null,
    "Du kannst in der Zwischenzeit weiterhin auf Winamax spielen."
  ],
  "You can deposit now to discover our poker and sports betting offer!": [
    null,
    "Du kannst jetzt einzahlen und unser Sportwettenangebot entdecken!"
  ],
  "You can finally risk it for that big accumulator!": [
    null,
    "Endlich kannst Du die Killer-Kombi-Wette wagen!"
  ],
  "You can only upload one file at a time. Choose wisely!": [
    null,
    "Du kannst nur eine Datei auf einmal hochladen. Überleg es dir genau!"
  ],
  "You can send this to us at a later time, but you must enter your information now.": [
    null,
    "Dies kannst du auch später noch tun. Die Informationen musst du aber jetzt schon eingeben."
  ],
  "You cannot create an account from your country.": [
    null,
    "Erstellung eines Kontos aus ihrem Land nicht durchführbar"
  ],
  "You have already transferred this file.": [
    null,
    "Du hast diesen Ordner bereits gesendet"
  ],
  "You have entered an invalid domiciliation code": [
    null,
    "Du hast eine ungültige Postleitzahl angegeben. "
  ],
  "You have entered an invalid phone number.": [
    null,
    "Du hast eine ungültige Telefonnummer angegeben."
  ],
  "You have insufficient CAPTCHA score to continue. Please try again later.": [
    null,
    "Deine CAPTCHA ist zu gering um fortzufahren. Bitte versuch es später erneut. "
  ],
  "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address.": [
    null,
    "Du hast dein Identitätsdokument erfolgreich hinzugefügt. Bitte stell sicher, dass deine Angaben korrekt sind und füge deine Anschrift hinzu. "
  ],
  "You have successfully made a request to change your password. Please check your emails.": [
    null,
    "Du hast eine erfolgreiche Anfrage zur Änderung deines Passworts durchgeführt. Bitte checke deine Mails. "
  ],
  "You must accept our Ts&Cs in order to create your account.": [
    null,
    "Du musst unseren AGB zustimmen, um ein Konto zu erstellen."
  ],
  "You must certify that you own this bank account.": [
    null,
    "Du musst bestätigen, dass du Eigentümer dieses Bankkontos bist."
  ],
  "You must choose a betting stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a deposit limit in order to make a deposit.": [
    null,
    "Du musst ein Einzahlungslimit festlegen, um eine Einzahlung tätigen zu können."
  ],
  "You must choose a password.": [
    null,
    "Du musst ein Passwort wählen."
  ],
  "You must choose a playtime limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a poker stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an automatic withdrawal limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an option for your sex in order to create your account.": [
    null,
    "Du musst eine Angabe zum Geschlecht machen, um einen Account zu erstellen."
  ],
  "You must enter a deposit amount.": [
    null,
    "Du musst einen Einzahlungsbetrag angeben."
  ],
  "You must enter an email or a phone number.": [
    null,
    "Du musst eine E-Mail-Adresse oder Telefonnummer angeben."
  ],
  "You must enter an iban number.": [
    null,
    "Du musst eine Iban-Nummer eingeben."
  ],
  "You must enter the full name displayed on your bank card in order to validate your deposit.": [
    null,
    "Du musst den gesamten Namen wie auf deiner Bankkarte angeben, um deine Einzahlung zu bestätigen."
  ],
  "You must enter your activation code in order to validate your account.": [
    null,
    "Du musst deinen Aktivierungscode eingeben, um deinen Account zu bestätigen."
  ],
  "You must enter your bank card cryptogram in order to validate your deposit.": [
    null,
    "Bitte gib das Kryptogramm deiner Karte an, um deine Einzahlung zu bestätigen."
  ],
  "You must enter your bank card expiry date in order to validate your deposit.": [
    null,
    "Du musst das Ablaufdatum deiner Karte angeben, um deine Einzahlung zu bestätigen."
  ],
  "You must enter your bank card number in order to validate your deposit.": [
    null,
    "Du musst deine Kartennummer angeben, um deine Einzahlung zu bestätigen."
  ],
  "You must enter your city of birth in order to create your account.": [
    null,
    "Dein Geburtsort wird zur Erstellung deines Account benötigt."
  ],
  "You must enter your city of residence in order to create your account.": [
    null,
    "Dein Wohnort wird zur Erstellung deines Accounts benötigt."
  ],
  "You must enter your country of birth in order to create your account.": [
    null,
    "Dein Geburtsland wird zur Erstellung deines Account benötigt."
  ],
  "You must enter your country of residence in order to create your account.": [
    null,
    "Dein Geburtsland wird zur Erstellung deines Accounts benötigt."
  ],
  "You must enter your date of birth in order to create your account.": [
    null,
    "Dein Geburtsdatum wird zur Erstellung deines Account benötigt."
  ],
  "You must enter your department of birth in order to create your account.": [
    null,
    "Du musst deinen Geburtsort angeben, um deinen Account zu erstellen."
  ],
  "You must enter your email in order to create your account.": [
    null,
    "Du musst eine E-Mail-Adresse angeben, um deinen Account zu erstellen."
  ],
  "You must enter your identity document number.": [
    null,
    "Bitte gib die Nummer des Identitäts-Douments an."
  ],
  "You must enter your phone number in order to create your account.": [
    null,
    "Bitte gib eine Telefonnummer an, um einen Account zu erstellen."
  ],
  "You must enter your postal address in order to create your account.": [
    null,
    "Dein Postanschrift wird zur Erstellung deines Account benötigt."
  ],
  "You must enter your postal code in order to create your account.": [
    null,
    "Deine Postleitzahl wird zur Erstellung deines Accounts benötigt."
  ],
  "You must enter your province to create your account.": [
    null,
    "Du musst dein Bundesland angeben, um dein Konto zu erstellen."
  ],
  "You must not be connected to the Winamax Poker software (desktop or mobile)": [
    null,
    "Du darfst nicht auf der Winamax-Software angemeldet sein (Computer, Smartphone, Tablet)"
  ],
  "You must provide your first name in order to create your account.": [
    null,
    "Dein Vorname wird zur Erstellung deines Account benötigt."
  ],
  "You must provide your last name in order to create your account.": [
    null,
    "Dein Name wird zur Erstellung deines Account benötigt."
  ],
  "You must provide your second last name in order to create your account.": [
    null,
    "Sie musst deinen zweiten Nachnamen angeben, um dein Konto zu erstellen"
  ],
  "You must upload your bank document.": [
    null,
    "Du musst dein Bank-Dokument hochladen. "
  ],
  "You need a username to play on Winamax.": [
    null,
    "Du benötigst einen Usernamen, um auf Winamax zu spielen."
  ],
  "You need to provide us with your ID and proof of address in order to complete your registration.": [
    null,
    "Du musst uns ein Ausweisdokument und einen Adress-Nachweis senden, um deine Registrierung abzuschließen."
  ],
  "You need to provide us with your ID in order to complete your registration.": [
    null,
    "Du musst uns ein Ausweisdokument senden, um deine Registrierung abzuschließen."
  ],
  "You will receive an activation code by post at the following address:": [
    null,
    "Du erhältst per Post einen Aktivierungscode an die folgende Adresse:"
  ],
  "You're too old!": [
    null,
    "Du bist zu alt!"
  ],
  "You're too young!": [
    null,
    "Du bist leider zu jung!"
  ],
  "You're way too young!": [
    null,
    "Du bist viel zu jung!"
  ],
  "Your ID upload has encountered an error": [
    null,
    "Bei deinem ID-Upload ist ein Fehler aufgetreten"
  ],
  "Your ID was registered successfully": [
    null,
    "Deine ID wurde erfolgreich registriert. "
  ],
  "Your account is being validated. You will receive a notification once your documents have been verified.": [
    null,
    "Dein Konto wird gerade überprüft. Du erhältst eine Benachrichtigung, sobald deine Dokumente überprüft worden sind."
  ],
  "Your account is frozen.": [
    null,
    "Ihr Konto ist blockiert."
  ],
  "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>": [
    null,
    "Dein Account wurde aufgeladen,<br /><b>Du kannst weiterhin auf Winamax spielen</b>"
  ],
  "Your account validation is being processed. You will be notified when your documents have been validated.": [
    null,
    "Deine Account-Validierung läuft. Du wirst benachrichtigt, sobald dein Account vollständig bestätigt ist."
  ],
  "Your address is not valid.": [
    null,
    "Deine Adresse ist ungültig. "
  ],
  "Your automatic withdrawal limit cannot be over %1$s digits.": [
    null,
    "Dein automatisches Auszahlungslimit darf nicht mehr als %1$s Zeichen haben. "
  ],
  "Your automatic withdrawal limit is too big.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be greater than or equal to your deposit limit.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be more than €200.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be over €0.": [
    null,
    "Dein automatisches Auszahlungslimit muss über 0 € liegen."
  ],
  "Your bank card cryptogram is not valid.": [
    null,
    "Das Kryptogramm deiner Bankkarte ist ungültig."
  ],
  "Your bank card expiry date is not valid.": [
    null,
    "Das Ablaufdatum deiner Bankkarte ist ungültig."
  ],
  "Your bank card number is not valid": [
    null,
    "Deine Kartennummer ist ungültig"
  ],
  "Your bet refunded in": [
    null,
    ""
  ],
  "Your betting stakes limit is too big.": [
    null,
    ""
  ],
  "Your betting stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your betting stakes limit per week is not valid.": [
    null,
    "Dein wöchentliches Sportwetten-Einsatzlimit ist ungültig. "
  ],
  "Your city cannot be over %1$s characters.": [
    null,
    "Dein Ort darf nicht mehr als %1$s Zeichen haben."
  ],
  "Your city is not valid.": [
    null,
    "Dein Ort ist ungültig."
  ],
  "Your city is required.": [
    null,
    "Dein Ort wird benötigt."
  ],
  "Your city of birth cannot be over %1$s characters.": [
    null,
    "Dein Geburtsort darf höchstens %1$s Zeichen enthalten."
  ],
  "Your city of birth is not valid.": [
    null,
    "Dein Geburtsort ist ungültig."
  ],
  "Your coordinates": [
    null,
    "Deine Angaben"
  ],
  "Your country cannot be over %1$s characters.": [
    null,
    "Dein Land darf nicht mehr als %1$s Zeichen haben."
  ],
  "Your country is not valid.": [
    null,
    "Dein Land ist ungültig."
  ],
  "Your country is required.": [
    null,
    "Dein Land wird benötigt."
  ],
  "Your country of birth is not valid.": [
    null,
    "Dein Geburtsland ist ungültig."
  ],
  "Your date of birth is not valid.": [
    null,
    "Dein Geburtsdatum ist ungültig."
  ],
  "Your date of birth must include 4 numbers.": [
    null,
    "Dein Geburtsdatum muss vier Zahlen enthalten. "
  ],
  "Your department of birth cannot be over %1$s characters.": [
    null,
    "Dein Geburtsort darf nicht mehr als %1$s Zeichen haben."
  ],
  "Your department of birth is not valid.": [
    null,
    "Dein Geburtsort ist ungültig."
  ],
  "Your deposit cannot be more than your weekly deposit limit: €%1$s.": [
    null,
    "Deine Einzahlung kann nicht höher als dein wöchentliches Einzahlungslimit sein: %1$s €."
  ],
  "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>": [
    null,
    "Dein Einzahlungslimit wurde gespeichert. <b>In 48 Stunden kannst du eine höhere Einzahlung vornehmen</b>"
  ],
  "Your deposit limit is too big.": [
    null,
    "Einzahlungslimt zu hoch."
  ],
  "Your deposit limit must be more than €0.": [
    null,
    "Dein Einzahlungslimit muss höher als 0 € sein."
  ],
  "Your deposit limit per week is not valid.": [
    null,
    "Dein wöchentliches Einzahlungslimit ist ungültig. "
  ],
  "Your deposit must be over €0.": [
    null,
    "Deine Einzahlung muss höher als 0 € sein."
  ],
  "Your document failed to upload": [
    null,
    "Deine Dokumente konnten nicht hochgeladen werden"
  ],
  "Your email cannot be over %1$s characters.": [
    null,
    "Deine E-Mail-Adresse darf höchstens %1$s Zeichen enthalten."
  ],
  "Your email is not valid.": [
    null,
    "Deine E-Mail-Adresse ist ungültig."
  ],
  "Your file is too big. Try again with a file smaller than %1$s Mb.": [
    null,
    "Deine Datei ist zu groß. Bitte versuch es erneut mit einer Datei-Größe von höchstens %1$s MB."
  ],
  "Your first bet refunded in cash if it loses": [
    null,
    ""
  ],
  "Your first name cannot be over %1$s characters.": [
    null,
    "Dein Vorname darf höchstens Zeichen %1$s haben."
  ],
  "Your first name is not valid.": [
    null,
    "Dein Vorname ist ungültig."
  ],
  "Your identity": [
    null,
    "Deine Identität"
  ],
  "Your identity corresponds to that of a minor.": [
    null,
    "Ihre persönlichen Daten entsprechen jenen einer minderjährigen Person."
  ],
  "Your identity corresponds to that of someone who has been registered as being deceased.": [
    null,
    "Deine Identität entspricht der einer Person, die als verstorben gemeldet ist."
  ],
  "Your information is being processed!": [
    null,
    "Deine Angaben werden verarbeitet!"
  ],
  "Your initial deposit in Freebets, up to €100*": [
    null,
    "Deine Freebets bis zu 100 €. "
  ],
  "Your last name cannot be over %1$s characters.": [
    null,
    "Dein Name darf höchstens Zeichen %1$s haben."
  ],
  "Your last name is not valid.": [
    null,
    "Dein Name ist ungültig."
  ],
  "Your limit cannot be €0": [
    null,
    "Dein Limit kann nicht 0 € betragen"
  ],
  "Your limit for %1$s must be inferior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be set between %2$s and %3$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to your %2$s limit": [
    null,
    ""
  ],
  "Your limit must be inferior or equal to %1$s": [
    null,
    "Dein Limit muss kleiner oder gleich %1$s sein"
  ],
  "Your limit must be set between %1$s and %2$s": [
    null,
    "Dein Limit muss zwischen %1$s und %2$s liegen"
  ],
  "Your limit must be superior or equal to %1$s": [
    null,
    "Dein Limit muss größer oder gleich %1$s sein"
  ],
  "Your name in the rankings will be:": [
    null,
    "Dein Name im Ranking wird sein:"
  ],
  "Your number will only be used to identify you": [
    null,
    "Deine Nummer wird nur genutzt, um dich zu identifizieren"
  ],
  "Your password cannot be over %1$s characters.": [
    null,
    "Dein Passwort darf nicht mehr als %1$s Zeichen haben. "
  ],
  "Your password is not valid.": [
    null,
    "Dein Passwort ist ungültig."
  ],
  "Your password must contain at least %1$s characters.": [
    null,
    "Dein Passwort muss mindestens %1$s Zeichen enthalten."
  ],
  "Your payment": [
    null,
    "Deine Zahlung"
  ],
  "Your phone number is mandatory in order to receive a new code.": [
    null,
    "Deine Telefonnummer wird benötigt, um einen neuen Code zu erhalten."
  ],
  "Your playtime limit must be more than 0 hours.": [
    null,
    ""
  ],
  "Your poker stakes limit is too big.": [
    null,
    ""
  ],
  "Your poker stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your poker stakes limit per week is not valid.": [
    null,
    "Dein wöchentliches Poker-Einsatzlimit ist ungültig. "
  ],
  "Your postal address cannot be over %1$s characters.": [
    null,
    "Deine Anschrift darf nicht mehr als %1$s Zeichen haben."
  ],
  "Your postal address is required.": [
    null,
    "Deine Anschrift wird benötigt."
  ],
  "Your postal code cannot be over %1$s characters.": [
    null,
    "Deine Postleitzahl darf nicht mehr als %1$s Zeichen haben."
  ],
  "Your postal code is required.": [
    null,
    "Deine Postleitzahl wird benötigt."
  ],
  "Your proof of address cannot be over one year old.": [
    null,
    "Der Adress-Nachweis darf nicht älter als ein Jahr sein."
  ],
  "Your session has expired.": [
    null,
    "Deine Verbindungszeit ist abgelaufen."
  ],
  "Your state is not valid.": [
    null,
    "Deine Region ist ungültig. "
  ],
  "Your story begins here!": [
    null,
    ""
  ],
  "Your turn to play": [
    null,
    "Ihr seid an der Reihe"
  ],
  "Your turn<br />to play": [
    null,
    "Du bist<br />an der Reihe"
  ],
  "Your username cannot contain over %1$s characters.": [
    null,
    "Dein Username darf höchstens %1$s Zeichen enthalten."
  ],
  "Your username is not valid, the only authorized special characters are: .&_- and space.": [
    null,
    "Dein Username ist nicht gültig: Die einzigen zugelassenen Sonderzeichen sind: &_- und Leerzeichen."
  ],
  "Your username must contain at least %1$s characters.": [
    null,
    "Dein Username muss mindestens %1$s Zeichen enthalten."
  ],
  "Your validation code is incorrect.": [
    null,
    "Ihr Bestätigungscode ist nicht korrekt. "
  ],
  "Your zip code is not valid.": [
    null,
    "Deine Postleitzahl ist ungültig. "
  ],
  "Your zip code of birth is not valid.": [
    null,
    "Die Postleitzahl deines Geburtsorts ist ungültig. "
  ],
  "and": [
    null,
    ""
  ],
  "and the": [
    null,
    ""
  ],
  "as well as our": [
    null,
    "sowie unser"
  ],
  "is being processed...": [
    null,
    "wird bearbeitet..."
  ],
  "of a super-player in progress...": [
    null,
    "eines Super-Spielers in der Entwicklung..."
  ],
  "of the ongoing payment...": [
    null,
    "der derzeitigen Zahlung..."
  ],
  "of your bank card processing...": [
    null,
    "Kartenzahlung wird bearbeitet..."
  ],
  "or": [
    null,
    "oder"
  ],
  "poker": [
    null,
    ""
  ],
  "promotions": [
    null,
    ""
  ],
  "sports betting": [
    null,
    ""
  ],
  "your document upload...": [
    null,
    "Dein Dokumenten-Upload..."
  ]
}
  }
}
